import { render, staticRenderFns } from "./BulkMessages.vue?vue&type=template&id=ddd848c6&"
import script from "./BulkMessages.vue?vue&type=script&lang=js&"
export * from "./BulkMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports